import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// Vises ÉN gang når man ankommer til webshoppen (ikke ved intern navigation,
// da StoreLayout forbliver monteret). Logo med langsom glow-sweep (~2s), fader/zoomer ud.
export function IntroLoader() {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShow(false), 2100);
    return () => clearTimeout(t);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 1.12 }}
          transition={{ duration: 0.65, ease: [0.4, 0, 0.2, 1] }}
          className="fixed inset-0 z-[200] flex items-center justify-center bg-background"
          data-testid="intro-loader"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="relative"
          >
            <div className="pointer-events-none absolute -inset-10 rounded-full bg-primary/25 blur-3xl animate-pulse" />
            <div className="relative overflow-hidden rounded-[2rem]">
              <img
                src="/brand/logo.png"
                alt="BARE 1 MERE"
                className="relative z-10 h-40 w-40 object-contain sm:h-52 sm:w-52"
                draggable="false"
              />
              <motion.div
                initial={{ x: "-140%" }}
                animate={{ x: "240%" }}
                transition={{ duration: 1.7, ease: "easeInOut" }}
                className="absolute inset-y-0 z-20 w-1/3 -skew-x-12 bg-gradient-to-r from-transparent via-white/70 to-transparent"
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
